import { mapState } from 'vuex'

export default {
  data: () => ({
    gateway: null,
    observer: null
  }),
  computed: mapState({
    referrerUrl: state => state.apps.referrerUrl
  }),
  mounted () {
    // make sure remove existing observer
    if (this.observer) {
      this.observer.disconnect()
    }

    // set observer to resize widget
    this.observer = new ResizeObserver(this.onResize)
    this.observer.observe(this.$refs.widget)
  },
  beforeDestroy () {
    // disconnect observer
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  created () {
    window.addEventListener('message', this.handleParentMessage)

    // set referrer if parent window into store
    if (this.$route.query.referrer) {
      this.$store.commit('apps/SET_REFERRER_URL', {
        referrerUrl: this.$route.query.referrer
      })
    }

    // check if is loaded in iframe
    if (window.self === window.top) {
      this.error = 'void'
      return false
    }
  },
  methods: {
    handleParentMessage (e) {
      /**
       * Handles the message event from the parent window.
       * @param {MessageEvent} e - The message event object.
       */
      if (e.data.event && e.data.event === 'set_options') {
        this.setOptions(e.data.value)
      }

      if (e.data.event && e.data.event === 'set_context') {
        this.setContext(e.data.value)
      }
    },
    onRedirect (url) {
      /**
       * Post message to widget library redirect to value event
       * @param {string} url - The url to redirect.
       */
      parent.postMessage({
        event: 'widget_redirect',
        value: url
      }, '*')
    },
    onResize (entries) {
      /**
       * Handles the resize event of the widget.
       *
       * @param {ResizeObserverEntry[]} entries - An array of ResizeObserverEntry objects.
       */
      for (let entry of entries) {
        const height = entry.contentRect.height

        // send new height to parent window
        parent.postMessage({
          event: 'widget_resize',
          value: height
        }, '*')
      }
    },
    setContext (value) {
      /**
       * Sets the context values based on the provided object.
       * @param {Object} value - The object containing the context values.
       * @returns {boolean} - Returns false if the provided value is falsy or not an object.
       */
      if (!value || typeof value !== 'object') {
        return false
      }

      Object.keys(value).forEach((k) => {
        const option = this.context[k]

        if (option && typeof value[k] === option.type) {
          this.context[k].value = value[k]
        }
      })
    },
    setLanguaje () {
      /**
       * Sets the language for the widget view.
       */
      this.$v.options.locale.value.$touch()

      if (this.$v.options.locale.value.$invalid) {
        console.info('Unsupported value in piriodSettings.options.locale, must be one of [es_MX, en_US, po_BR]')
      } else {
        this.$i18n.locale = this.options.locale.value
      }
    },
    setOptions (value) {
      /**
       * Sets the options for the widget view.
       * @param {Object} value - The options to be set.
       * @returns {boolean} - Returns false if the value is not an object or is falsy.
       */
      if (!value || typeof value !== 'object') {
        return false
      }

      Object.keys(value).forEach((k) => {
        const option = this.options[k]

        if (option && typeof value[k] === option.type) {
          this.options[k].value = value[k]
        }
      })

      if (typeof this.setCustomOptions === 'function') {
        this.setCustomOptions()
      }
    }
  }
}